import React from "react";
import { createChatBotMessage } from "react-chatbot-kit";
// import HeaderText from "../components/HeaderText/HeaderText";
import BotAvatar from "../components/BotAvatar/BotAvatar";
import Options from "../components/Widgets/Options/Options";


import 'bootstrap/dist/css/bootstrap.css'
import Agent from "../components/Widgets/SatisfactoryWidget/Agent";
import FlightNumber from "../components/Widgets/FlightNumber/FlightNumber";
import SatisfactoryWidget from "../components/Widgets/SatisfactoryWidget/SatisfactoryWidget";
import SecondOptions from "../components/Widgets/SatisfactoryWidget/SecondOptions";
import HotelArea from "../components/Widgets/HotelAreaWidget/HotelArea";
import tripzHeader from '../images/tripz-header.svg'


const config = {
  
    
  initialMessages: [createChatBotMessage(`Hi there. Welcome to Tripz. My name is Lydia. How can I help you today?`, {
    widget:'options',
  })],
  
  customComponents: {
    
    botAvatar: (props) => <BotAvatar {...props}/>,
    header: (props) => {
      return (
        <div className='bot-header p-1 ps-3'>
        <div className='d-flex gap-3'>
  
         
         <img src={tripzHeader} alt='Tripz' style={{width:'50px', height:'50px'}}className="botname-icon my-auto"/>
         
         <div className='bot-text mt-3'>
         <h6>Lydia </h6>
         <p className="">Online</p>
         </div>
         
         </div>
       
     </div>
      )
      
     
    }
    
  
  },
 
  widgets: [
    {
        widgetName: 'options',
        widgetFunc: (props) => 
       <Options {...props}/>
        
    },
   
    {
      widgetName: 'flightNumber',
      widgetFunc: (props)=><FlightNumber {...props}/>
    },
    {
      widgetName: 'satisfactory',
      widgetFunc: (props) => <SatisfactoryWidget {...props}/>,
     },
    
     {
      widgetName: 'secondOptions',
      widgetFunc: (props) => <SecondOptions {...props}/>,
     },
     {
      widgetName: 'hotelArea',
      widgetFunc: (props) => <HotelArea {...props}/>,
     },
     
]
}

export default config